const webp = (src) => (/^\/img\/.+\.(jpe?g|png)$/i.test(src) ? src.replace(/\.(jpe?g|png)$/i, ".webp") : null);

export const Pic = ({ src, alt, className, loading = "lazy", fetchPriority, ...rest }) => {
  const w = webp(src || "");
  const img = <img src={src} alt={alt} loading={loading} decoding="async" fetchPriority={fetchPriority} className={className} {...rest} />;
  if (!w) return img;
  return (
    <picture className="contents">
      <source type="image/webp" srcSet={w} />
      {img}
    </picture>
  );
};
